import styled from "styled-components";

export default function GroupSection({ children }) {
  return <Block>{children}</Block>;
}

const Block = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(133, 133, 133, 0.26);
  border-radius: 14px;
  padding: 0 calc(100vw * (16 / 375));
  padding-top: calc(100vw * (11 / 375));
  margin-bottom: calc(100vw * (11.5 / 375));
`;
